import { manageCssClasses as a, sortArrayOfObjects as s } from "helper-functions-library";
import '../assets/SelectComponent.css';const l = "op_selectDefault_9CVVm", r = {
  selectDefault: l
};
function i(t) {
  let e = null, o = a({ defaultClasses: r.selectDefault, attributes: t });
  return t.options !== void 0 && (e = [...t.options].map(n), delete t.options), /* @__PURE__ */ React.createElement(
    "select",
    {
      ...t,
      className: o
    },
    e
  );
}
function n(t, e) {
  return t.type !== void 0 && t.type == "optgroup" ? /* @__PURE__ */ React.createElement("optgroup", { ...t }, t.optGroupOptions.map(n)) : /* @__PURE__ */ React.createElement("option", { ...t }, t == null ? void 0 : t.name);
}
function u(t) {
  return s({ array: t, sortBy: "label" });
}
function p(t) {
  return t.unshift({ value: "", label: "" }), t;
}
export {
  i as SelectComponent,
  p as addEmptyOptionsEntry,
  u as sortedOptionsByLabel
};
